import { render, staticRenderFns } from "./PaymentTypeList.vue?vue&type=template&id=1905e707"
import script from "./PaymentTypeList.vue?vue&type=script&lang=js"
export * from "./PaymentTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports